import state from './state'

let Ammo
let rigidBodies = []
let softBodies = []
let physicsWorld
let transformAux1

export default function initPhysics() {
  const broadphase = new Ammo.btDbvtBroadphase()
  const collisionConfiguration = new Ammo.btSoftBodyRigidBodyCollisionConfiguration()
  const dispatcher = new Ammo.btCollisionDispatcher(collisionConfiguration)
  const solver = new Ammo.btSequentialImpulseConstraintSolver()
  const softBodySolver = new Ammo.btDefaultSoftBodySolver()

  physicsWorld = new Ammo.btSoftRigidDynamicsWorld(
    dispatcher,
    broadphase,
    solver,
    collisionConfiguration,
    softBodySolver,
  )

  physicsWorld.setGravity(
    new Ammo.btVector3(0, state.physics.gravity.constant, 0),
  )

  physicsWorld
    .getWorldInfo()
    .set_m_gravity(new Ammo.btVector3(0, state.physics.gravity.constant, 0))

  transformAux1 = new Ammo.btTransform()
}

export { Ammo, physicsWorld, rigidBodies, softBodies, transformAux1 }

// For whatever reason the library initializes asynchronously
export function setAmmo(_Ammo) {
  Ammo = _Ammo
}
